import { render, staticRenderFns } from "./SignUpView.vue?vue&type=template&id=12bf62aa"
import script from "./SignUpView.vue?vue&type=script&lang=ts"
export * from "./SignUpView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports